import store from '@state/store.js'
import { start } from '@/services/signalr/startSignalR'
import buildConnection from '@/services/signalr/buildConnection'
import getSignalRToken from '@/services/signalr/getSignalRToken.js'

let connection = null
let connectionAttemps = 0
const connectionAttempsMax = 4

export default {
  install(Vue) {
    // use new Vue instance as an event bus
    const signalRHub = new Vue()

    // every component will use this.$signalRHub to access the event bus
    Vue.prototype.$signalRHub = signalRHub

    // Set up event bus functions
    signalRHub.start = start

    signalRHub.login = (qsKey, key) => {
      return startedPromise
        .then(() => connection.invoke('AuthMe', qsKey, key))
        .catch(console.error)
    }
    signalRHub.sendMsg = (name, string) => {
      return startedPromise
        .then(() => connection.invoke('Send', name, string))
        .catch(console.error)
    }
    signalRHub.joinRoom = (name) => {
      return startedPromise
        .then(() => connection.invoke('JoinRoom', name))
        .catch(console.error)
    }
    signalRHub.createRoom = () => {
      return startedPromise
        .then(() => connection.invoke('CreateRoom'))
        .catch(console.error)
    }
    signalRHub.whoisIn = () => {
      return startedPromise
        .then(() => connection.invoke('TaskWhosInMyRoom'))
        .catch(console.error)
    }
    signalRHub.getRoom = () => {
      return startedPromise
        .then(() => connection.invoke('GetRoom'))
        .catch(console.error)
    }
    signalRHub.isConnected = () => {
      return !!connection
    }
    signalRHub.disconnect = () => {
      connection = null
      Vue.prototype.$signalrConn = connection
    }
    signalRHub.connect = () => {
      connection = buildConnection()
      Vue.prototype.$signalrConn = connection

      // Forward server side SignalR events through $signalRHub, where components will listen to them
      connection.on('broadcastMessage', (msg) => {
        signalRHub.$emit('broadcast-msg', msg)
      })

      connection.on('authed', () => {
        console.info('Authenticated to SignalR')
        store.dispatch('message/loadMessages')
        signalRHub.$emit('authed')
        connectionAttemps = 0
      })

      connection.on('Not Authed', () => {
        console.info('Not Authenticated to SignalR')
        signalRHub.disconnect()
        connectionAttemps = 0
      })

      connection.on('InboundMessage', async (msg) => {
        // Insert message to store for candidate-list & notification handling
        store.dispatch('message/insertInboundMessage', msg)

        // Check if the candidate/contact who sent it is being currently viewed
        if (msg.id === store.getters['message/currentlyViewing']) {
          store.dispatch('message/setMessageToRead', msg)
        }
      })

      connection.on('roomDetails', (details) => {
        console.log('roomDetails')
        signalRHub.$emit('received-room', JSON.parse(details))
      })

      connection.on('joinedRoom', (roomID) => {
        signalRHub.$emit('joined-room', roomID)
      })

      connection.on('roomList', (roomID) => {
        signalRHub.$emit('whois-in', roomID)
      })

      connection.on('joinedRoomFail', (roomID) => {
        alert('FAILED' + roomID)
      })

      connection.onclose(async () => {
        connectionAttemps++

        // Regen new tokens
        await getSignalRToken()

        // Generate new connection
        signalRHub.connect()

        if (connectionAttemps <= connectionAttempsMax) {
          // Start signalr
          startedPromise = start()
          return startedPromise
        } else {
          console.warn(
            'Signalr: Max number of connection attempts exceeded. Disconnecting...'
          )
          signalRHub.disconnect()
        }
      })
    }

    // Init connection
    signalRHub.connect()

    let startedPromise = null

    startedPromise = start()
  },
}
